import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { logoutUser } from '../authService';
import { BrandLens } from './ui/CelestialShell';

const activeClass = ({ isActive }) => `br-nav__link ${isActive ? 'is-active' : ''}`;
const mobileClass = ({ isActive }) => (isActive ? 'is-active' : '');

export default function Navbar() {
  const { authState, setAuthState } = useAuth();
  const location = useLocation();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    setMobileMenuOpen(false);
    setSettingsOpen(false);
  }, [location.pathname]);

  if (authState.loading || ['/', '/login', '/register', '/auth', '/recover', '/reset-password', '/terms', '/privacy', '/contact', '/support'].includes(location.pathname)) return null;
  if (!authState.isAuthenticated) return null;

  const handleLogout = async () => {
    try {
      await logoutUser();
    } catch (error) {
      console.error('Logout API failed:', error);
    }
    document.cookie = 'jwt=; Max-Age=0; path=/; Secure; SameSite=Strict;';
    localStorage.removeItem('jwt');
    setAuthState({ isAuthenticated: false, user: null, loading: false });
    window.setTimeout(() => window.location.replace('/login'), 100);
  };

  const isAdmin = authState?.user?.username === 'admin';

  return (
    <div className="br-nav-shell">
      <nav className="br-nav" aria-label="Primary navigation">
        <Link to="/chat" className="br-nav__brand" aria-label="BrightResolve Chat">
          <BrandLens size="small" />
          <span className="br-nav__brand-name">BrightResolve</span>
        </Link>

        <div className="br-nav__links">
          <NavLink to="/chat" className={activeClass}>Chat</NavLink>
          <NavLink to="/profile" className={activeClass}>Profile</NavLink>
          <NavLink to="/settings" className={activeClass}>Settings</NavLink>
        </div>

        <div className="br-nav__actions">
          <div className="br-nav__menu-wrap" style={{ position: 'relative' }}>
            <button type="button" className="br-nav__menu-button" onClick={() => setSettingsOpen((open) => !open)} aria-expanded={settingsOpen}>
              Account
            </button>
            {settingsOpen && (
              <div className="br-nav__dropdown">
                {isAdmin && <NavLink to="/admin/audit-log">System audit</NavLink>}
                <button type="button" onClick={handleLogout}>Sign out</button>
              </div>
            )}
          </div>
          <button type="button" className="br-nav__mobile-toggle" aria-label="Toggle navigation" aria-expanded={mobileMenuOpen} onClick={() => setMobileMenuOpen((open) => !open)}>
            <span aria-hidden="true">{mobileMenuOpen ? '×' : '☰'}</span>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="br-nav__mobile">
            <NavLink to="/chat" className={mobileClass}>Chat</NavLink>
            <NavLink to="/profile" className={mobileClass}>Profile</NavLink>
            <NavLink to="/settings" className={mobileClass}>Settings</NavLink>
            {isAdmin && <NavLink to="/admin/audit-log" className={mobileClass}>System audit</NavLink>}
            <button type="button" onClick={handleLogout}>Sign out</button>
          </div>
        )}
      </nav>
    </div>
  );
}
